/**
 * 5인 미만 선택(오버라이드) Firestore 저장/조회
 * 설계문서: required/5인미만/5인이상.md §10.2, §10.3
 * 경로: sharedBooks/{shareBookId}/accountSettings/account_{accountNumber}
 */

import { getFirestore, doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebaseService';

export type BusinessScaleOverrideValue = 'under5' | 'auto';

const getAccountSettingsPath = (shareBookId: string) =>
  `sharedBooks/${shareBookId}/accountSettings`;

export async function getBusinessScaleOverride(
  shareBookId: string,
  accountNumber: number
): Promise<BusinessScaleOverrideValue> {
  const ref = doc(db, getAccountSettingsPath(shareBookId), `account_${accountNumber}`);
  const snap = await getDoc(ref);
  const v = snap.exists() ? snap.data()?.business_scale_override : null;
  return v === 'under5' ? 'under5' : 'auto';
}

export async function setBusinessScaleOverride(
  shareBookId: string,
  accountNumber: number,
  value: BusinessScaleOverrideValue
): Promise<void> {
  const ref = doc(db, getAccountSettingsPath(shareBookId), `account_${accountNumber}`);
  await setDoc(
    ref,
    { business_scale_override: value, updated_at: serverTimestamp() },
    { merge: true }
  );
}

export { getAccountSettingsPath };
